import { Button } from "@mui/material";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { useContext } from "react";

import { createMeetingURL } from "../../../utils/create-meeting-url";
import { AuthContext } from "../../../context";

interface JoinMeetingProps {
  meetingId: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

const JoinMeetingButton: React.FC<JoinMeetingProps> = ({
  meetingId,
  disabled = false,
  fullWidth = true,
}) => {
  const { userId } = useContext(AuthContext);

  const url = createMeetingURL(
    window.location.origin,
    meetingId,
    userId,
  );

  const openInNewTab = () => {
    window.open(url, "_blank");
  };

  return (
    <Button
      fullWidth={fullWidth}
      onClick={openInNewTab}
      disabled={disabled}
      variant="contained"
      color="primary"
      startIcon={<PhoneInTalkIcon />}
      sx={{
        borderRadius: "1.5rem",
        fontWeight: 600,
      }}
    >
      Join Meeting
    </Button>
  );
};

export default JoinMeetingButton;
